const data = [
  {
    title: 'dagster-slurm',
    subtitle: 'Open source. Published in the Journal of Open Source Software',
    link: 'https://github.com/ascii-supply-networks/dagster-slurm',
    image: '/images/projects/dagster-slurm.png',
    date: '2026-03-19',
    desc: 'Runs Dagster assets on Slurm HPC clusters. The same asset code runs on '
      + 'a laptop and on a supercomputer with almost no config change. It packages '
      + 'environments with pixi, pools SSH connections, and collects Slurm job metrics. '
      + 'I am the first author of the JOSS paper that describes it.',
  }, 
  {
    title: 'Metaxy',
    subtitle: 'Open source. Metadata layer for multimodal pipelines',
    link: 'https://github.com/anam-org/metaxy',
    image: '/images/projects/metaxy.png',
    date: '2025-10-13',
    desc: 'Tracks lineage and versioning for multimodal data and ML pipelines at the '
      + 'level of single samples. It detects prunable updates, so a change upstream '
      + 'does not force every downstream branch to recompute. I help with reviews '
      + 'and implementation.',
  },  
  {
    title: 'ASCII Hydra',
    subtitle: 'Open source. Published in the Journal of Open Source Software',
    link: 'https://github.com/ascii-supply-networks/ascii-hydra',
    image: '/images/projects/ascii-hydra.png',
    date: '2024-12-15',
    desc: 'Shows how to build Dagster assets that run on local PySpark, Databricks '
      + 'or AWS EMR without changing the pipeline code. The point is to avoid lock-in '
      + 'to one cloud platform and to cut cost. I submitted the JOSS paper on it.',
  },
  {
    title: 'Simbu',
    subtitle: 'COVID-19 Data Challenge, 2nd Prize',
    image: '/images/projects/simbu.jpg',
    date: '2020-05-20',
    desc: 'Built for the UCSD COVID-19 Data Challenge. It gives people the information '
      + 'they need to make decisions. It keeps the user anonymous and strengthens the '
      + 'links inside a community.',
  }, {
    title: 'Shadow voter',
    subtitle: 'Developed at UCSD under Prof. Scott Desposato',
    image: '/images/projects/vote.jpg',
    date: '2019-01-07',
    desc: 'We used neural networks for face recognition to identify the people who '
      + 'appear in political spots from Latin America, beyond the candidate. We then '
      + 'used that to test the shadow voter hypothesis.',
  }, {
    title: 'Information direction',
    subtitle: 'Detecting media manipulation in China',
    image: '/images/projects/media.jpg',
    date: '2017-06-28',
    desc: 'We ran statistical analysis over Weibo and news data to detect plagiarism '
      + 'in the news. We checked whether the timing and the topic were related.',
  },
];

export default data;
